import { range } from 'lodash'

export const isDef = (value?: string | number | null) =>
	!(value === undefined || value === null || value === '')

export const getFormat = (decimals?: number) =>
	decimals ? `0,0.[${range(0, decimals - 1).map(() => '0')}]` : undefined
